package one.healthium.ui.common.utils

import androidx.window.core.layout.WindowSizeClass

fun WindowSizeClass.isMedium(): Boolean {
    return this.isWidthAtLeastBreakpoint(WindowSizeClass.WIDTH_DP_MEDIUM_LOWER_BOUND)
}